export interface QueryOptionsDTO {
  pageIndex?: number;
  pageSize?: number;
  sortField?: string;
  sortDirection?: SortDirection;
  searchString?: string;
}

export enum SortDirection {
  Ascending = 0,
  Descending = 1,
}
